import { getApp, getApps, initializeApp } from 'firebase/app'
import { FIREBASE_CONFIG } from '~/lib/config'

export const firebaseApp = getApps().length ? getApp() : initializeApp(FIREBASE_CONFIG)
